export const useWebView = () => {
  const { query } = useRoute();

  const isWebView = computed(() => query.webView === 'true');

  return {
    isWebView
  };
};
